const state = {
  isDrawerOpen: false,
  isMaskShow: false,
  lockBodyScroll: false,
  navTitle: '首页',
};

export default state;
